import { Modal } from "@asurion-core/aui-react-modal";
import { Action } from "@asurion-core/mx-asurion-ui-react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

export enum ClockAction {
  ClockOut = "clockOut",
  GoOnBreak = "goOnBreak",
  ReturnFromBreak = "returnFromBreak"
}

interface ConfirmClockActionModalProps {
  action: ClockAction;
  isLoading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const StyledFooter = styled(Modal.Footer)`
  padding-top: 1.5rem;
  border-top: 1px solid #d5d6da;
  display: flex;
  gap: 0.75rem;
`;

const StyledTitle = styled(Modal.Title)`
  font-weight: 700;
`;

export function ConfirmClockActionModal({ action, isLoading, onConfirm, onCancel }: ConfirmClockActionModalProps) {
  const { t } = useTranslation("root-config");

  const actionConfig = {
    [ClockAction.ClockOut]: { title: t("ConfirmClockOutTitle"), body: t("ConfirmClockOutBody") },
    [ClockAction.GoOnBreak]: { title: t("ConfirmGoOnBreakTitle"), body: t("ConfirmGoOnBreakBody") },
    [ClockAction.ReturnFromBreak]: { title: t("ConfirmReturnFromBreakTitle"), body: t("ConfirmReturnFromBreakBody") }
  };

  const { title, body } = actionConfig[action];

  return (
    <Modal isOpen={true} isSticky={false} onCloseModal={onCancel}>
      <Modal.Header>
        <StyledTitle>{title}</StyledTitle>
      </Modal.Header>
      <Modal.Content>{body}</Modal.Content>
      <StyledFooter>
        <Action disabled={isLoading} state={isLoading ? "loading" : "enabled"} onClick={onConfirm}>
          {t("Confirm")}
        </Action>
        <Action variant="flat" disabled={isLoading} onClick={onCancel}>
          {t("Cancel")}
        </Action>
      </StyledFooter>
    </Modal>
  );
}
